import React from "react";
import classnames from "classnames";
// javascript plugin used to create scrollbars on windows
import PerfectScrollbar from "perfect-scrollbar";
// reactstrap components
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  Label,
  FormGroup,
  Form,
  Input,
  FormText,
  NavItem,
  NavLink,
  Nav,
  Table,
  TabContent,
  TabPane,
  Container,
  Row,
  Col,
  UncontrolledTooltip,
  UncontrolledCarousel,
} from "reactstrap";

// core components
import IndexNavbar from "components/Navbars/IndexNavbar.js";
import Footer from "components/Footer/Footer.js";


let ps = null;

export default function ContactPage() {
  const [tabs, setTabs] = React.useState(1);
  React.useEffect(() => {
    document.body.classList.toggle("profile-page");
  }, []);

  return (
    <>
      <IndexNavbar />
      <div className="wrapper">
        <div className="page-header">
          <img
            alt="..."
            className="dots"
            src={require("assets/img/dots.png")}
          />
          <img
            alt="..."
            className="path"
            src={require("assets/img/path4.png")}
          />
          <br/>
          <br/>
          <br/>
          <br/>
          <h1 className="text-center mt-5">Nossos pastores</h1>
        <section className="section">
          
          <Container className="align-items-center">
                      <Row>
                      <Col className="ml-auto mr-auto" lg="4" md="6">
                        <img
                                alt="..."
                                className="img-center img-fluid rounded-circle"
                                src={"/pastores/pastor_felipe_e_mila_parente_vermelho.png"}
                              />
                        </Col>                        
                        <Col lg="6" md="6">
                          <h1 className="profile-title text-left">Pastor Felipe e Mila Parente</h1>
                          <h5 className="text-on-back">01</h5>
                          <p className="profile-description">
                            Siga no Instagram!
                          </p>
                          <div className="btn-wrapper profile pt-3">
                            <Button
                              className="btn-icon btn-round"
                              color="instagram"
                              href="https://www.instagram.com/prfelipeparente"
                              id="tooltip639225725"
                              target="_blank"
                            >
                              <i className="fab fa-instagram" />
                            </Button>
                            <UncontrolledTooltip delay={0} target="tooltip639225725">
                              Siga o Pastor Felipe
                            </UncontrolledTooltip>

                            <Button
                              className="btn-icon btn-round"
                              color="instagram"
                              href="https://www.instagram.com/milamelettiparente"
                              id="tooltipMIla"
                              target="_blank"
                            >
                              <i className="fab fa-instagram" />
                            </Button>
                            <UncontrolledTooltip delay={0} target="tooltipMIla">
                              Siga a Pastor(a) Mila
                            </UncontrolledTooltip>                            

                            
                          </div>
                        </Col>
                        
                      </Row>
                    </Container>
        </section>      
  
        <section className="section">
        <img alt="..." className="path" src={require("assets/img/path1.png")} />
        <img
            alt="..."
            className="path path1"
            src={require("assets/img/path3.png")}
        />             
          <Container className="align-items-center">
                      <Row>
                        <Col lg="6" md="6">
                          <h1 className="profile-title text-left">Pastor Lucas e Kássya</h1>
                          <h5 className="text-on-back">02</h5>
                          <p className="profile-description">
                          Siga no Instagram!
                          </p>
                          <div className="btn-wrapper profile pt-3">
                            <Button
                              className="btn-icon btn-round"
                              color="instagram"
                              href="https://www.instagram.com/lucas_cahet"
                              id="tooltipLucas"
                              target="_blank"
                            >
                              <i className="fab fa-instagram" />
                            </Button>
                            <UncontrolledTooltip delay={0} target="tooltipLucas">
                              Siga o Pastor Lucas
                            </UncontrolledTooltip>

                            <Button
                              className="btn-icon btn-round"
                              color="instagram"
                              href="https://www.instagram.com/kassyadepaulap"
                              id="tooltipKa"
                              target="_blank"
                            >
                              <i className="fab fa-instagram" />
                            </Button>
                            <UncontrolledTooltip delay={0} target="tooltipKa">
                              Siga a Pastor(a) Kássya
                            </UncontrolledTooltip> 
                          </div>
                        </Col>
                        <Col className="ml-auto mr-auto" lg="4" md="6">
                        <img
                                alt="..."
                                className="img-center img-fluid rounded-circle"
                                src={"/pastores/pastor_lucas_e_kassya_vermelho.png"}
                              />
                        </Col>
                      </Row>
                    </Container>
        </section>

        
        <section className="section">
          <Container className="align-items-center">
                      <Row>
                      <Col className="ml-auto mr-auto" lg="4" md="6">
                        <img
                                alt="..."
                                className="img-center img-fluid rounded-circle"
                                src={"/pastores/pastor_osmar_e_eneida_vermelho.png"}
                              />
                        </Col>                        
                        <Col lg="6" md="6">
                          <h1 className="profile-title text-left">Pastor Osmar e Eneida</h1>
                          <h5 className="text-on-back">03</h5>
                          <p className="profile-description">
                          Siga no Instagram!
                          </p>
                          <div className="btn-wrapper profile pt-3">
                            <Button
                              className="btn-icon btn-round"
                              color="instagram"
                              href="https://www.instagram.com/osmarchecon"
                              id="tooltiposmar"
                              target="_blank"
                            >
                              <i className="fab fa-instagram" />
                            </Button>
                            <UncontrolledTooltip delay={0} target="tooltiposmar">
                              Siga o Pastor Osmar
                            </UncontrolledTooltip>

                            <Button
                              className="btn-icon btn-round"
                              color="instagram"
                              href="https://www.instagram.com/checoneneida"
                              id="tooltipEne"
                              target="_blank"
                            >
                              <i className="fab fa-instagram" />
                            </Button>
                            <UncontrolledTooltip delay={0} target="tooltipEne">
                              Siga a Pastor(a) Eneida
                            </UncontrolledTooltip>                            

                            
                          </div>
                        </Col>
                        
                      </Row>
                    </Container>
        </section>

        <section className="section">
        <img alt="..." class="path path1 left" src={require("assets/img/path1.png")} />
          <Container className="align-items-center">
                      <Row>
                        <Col lg="6" md="6">
                          <h1 className="profile-title text-left">Pastor Wesley e Claise</h1>
                          <h5 className="text-on-back">04</h5>
                          <p className="profile-description">
                          Siga no Instagram!
                          </p>
                          <div className="btn-wrapper profile pt-3">
                            <Button
                              className="btn-icon btn-round"
                              color="instagram"
                              href="https://www.instagram.com/wesley.c.i.n"
                              id="tooltipwesley"
                              target="_blank"
                            >
                              <i className="fab fa-instagram" />
                            </Button>
                            <UncontrolledTooltip delay={0} target="tooltipwesley">
                              Siga o Pastor Wesley
                            </UncontrolledTooltip>

                            <Button
                              className="btn-icon btn-round"
                              color="instagram"
                              href="https://www.instagram.com/claise.lcs"
                              id="tooltipCla"
                              target="_blank"
                            >
                              <i className="fab fa-instagram" />
                            </Button>
                            <UncontrolledTooltip delay={0} target="tooltipCla">
                              Siga a Pastor(a) Claise
                            </UncontrolledTooltip> 
                          </div>
                        </Col>
                        <Col className="ml-auto mr-auto" lg="4" md="6">
                        <img
                                alt="..."
                                className="img-center img-fluid rounded-circle"
                                src={"/pastores/pastor_wesley_e_claise_vermelho.png"}
                              />
                        </Col>
                      </Row>
                    </Container>
        </section>        
        </div>
        <Footer />
      </div>
    </>
  );
}
